export const drawerContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '4px',
  flex: 1,
  minWidth: 0,
  height: '100%',
};

export const subtitleStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const searchRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const listStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  flex: 1,
  overflowY: 'auto',
};

export const emptyStateStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
  color: ({ palette }) => palette.text.secondary,
};
